interface WithTimeoutOptions<T> {
  timeoutMs: number
  onTimeout: () => T | Promise<T>
}

export async function withTimeout<T>(
  operation: Promise<T>,
  { timeoutMs, onTimeout }: WithTimeoutOptions<T>,
): Promise<T> {
  let timeoutId: ReturnType<typeof setTimeout> | undefined

  try {
    return await Promise.race([
      operation,
      new Promise<T>((resolve, reject) => {
        timeoutId = setTimeout(() => {
          void Promise.resolve().then(onTimeout).then(resolve, reject)
        }, timeoutMs)
      }),
    ])
  } finally {
    if (timeoutId != null) {
      clearTimeout(timeoutId)
    }
  }
}
